import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { API } from '../../services/api';
const api = new API();

import { changeItemOwner } from '../itemOwner/itemOwnersSlice';

export const fetchWheel = createAsyncThunk(
  'wheel/get',
  async (data, thunkAPI) => {
    try {
      const { ownerId, wheelId } = data;
      const response = await api.getWheel(ownerId, wheelId);

      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: wheel/get', e.message);

      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

export const saveWheelDraft = createAsyncThunk(
  'wheel/save/draft',
  async (data, thunkAPI) => {
    try {
      const { itemOwnerId, wheelId, wheelData } = data;

      const response = await api.saveDraftWheel(itemOwnerId, wheelId, wheelData);

      if(response.status === 'ok') {
        return wheelData;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: wheel/save/draft', e.message);

      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

export const saveWheelPublished = createAsyncThunk(
  'wheel/save/published',
  async (data, thunkAPI) => {
    try {
      const { itemOwnerId, wheelId, wheelData } = data;

      const response = await api.savePublishedWheel(itemOwnerId, wheelId, wheelData);

      if(response.status === 'ok') {
        return wheelData;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: wheel/save/published', e.message);

      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

export const publishWheel = createAsyncThunk(
  'wheel/publish',
  async (data, thunkAPI) => {
    try {
      const { itemOwnerId, wheelId, wheelData } = data;

      const response = await api.publishWheel(itemOwnerId, wheelId, wheelData);

      if(response.status === 'ok') {
        return wheelData;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: wheel/publish', e.message);

      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
)

export const createWheel = createAsyncThunk(
  'wheel/create',
  async (data, thunkAPI) => {
    try {
      const { itemOwnerId, wheelData } = data;
      const response = await api.createWheel(itemOwnerId, wheelData);

      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      console.error('ERROR: wheel/create', e.message);
      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

const initialState = {
  draft: {},
  published: {},
  master: {},
  equalStatus: false,
  canEdit: false,
  fetchStatus: 'idle',
  fetchError: null,
  createStatus: 'idle',
  createError: null,
  saveStatus: 'idle',
  saveError: null
};

export const wheelSlice = createSlice({
  name: 'wheel',
  initialState,
  reducers: {
    clearSaveStatus: (state, action) => {
      state.saveStatus = 'idle';
    },
    clearCreateStatus: (state, action) => {
      state.createStatus = 'idle';
    },
    resetStatus: (state, action) => {
      return initialState;
    }
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchWheel.fulfilled]: (state, action) => {
      state.fetchStatus = 'succeeded';
      state.fetchError = null;

      state.draft = action.payload.draft || {};
      state.published = action.payload.published?.code ? action.payload.published : {};
      state.master = action.payload.master || {};
      state.equalStatus = action.payload.equalStatus;
      state.canEdit = action.payload.canEdit;
    },
    [fetchWheel.pending]: (state, action) => {
      state.fetchStatus = 'loading';
      state.fetchError = null;
    },
    [fetchWheel.rejected]: (state, action) => {
      state.fetchStatus = 'failed';
      state.fetchError = action.payload.messages.join(', ');
    },

    [saveWheelDraft.fulfilled]: (state, action) => {
      state.saveStatus = 'succeeded';
      state.saveError = null;
      state.draft = action.payload;
      state.equalStatus = false;
    },
    [saveWheelDraft.pending]: (state, action) => {
      state.saveStatus = 'loading';
      state.saveError = null;
    },
    [saveWheelDraft.rejected]: (state, action) => {
      state.saveStatus = 'failed';

      if(typeof action.payload === 'string') {
        state.saveError = {
          message: action.payload
        };
      } else {
        state.saveError = {
          message: action.payload.messages.join(', '),
          fields: action.payload.result.errors
        };
      }
    },

    [saveWheelPublished.fulfilled]: (state, action) => {
      state.saveStatus = 'succeeded';
      state.saveError = null;
      state.published = action.payload;
      state.equalStatus = false;
    },
    [saveWheelPublished.pending]: (state, action) => {
      state.saveStatus = 'loading';
      state.saveError = null;
    },
    [saveWheelPublished.rejected]: (state, action) => {
      state.saveStatus = 'failed';

      if(typeof action.payload === 'string') {
        state.saveError = {
          message: action.payload
        };
      } else {
        state.saveError = {
          message: action.payload.messages.join(', '),
          fields: action.payload.result.errors
        };
      }
    },

    [publishWheel.fulfilled]: (state, action) => {
      state.saveStatus = 'succeeded';
      state.saveError = null;
      state.published = action.payload;
      state.draft = action.payload;
      state.equalStatus = true;
    },
    [publishWheel.pending]: (state, action) => {
      state.saveStatus = 'loading';
      state.saveError = null;
    },
    [publishWheel.rejected]: (state, action) => {
      state.saveStatus = 'failed';
      console.log('action', action);

      let message = 'INTERNAL_SERVER_ERROR';

      if(typeof action.payload === 'string') {
        // error message
        message = action.payload;
      } else if(action.payload.messages.length) {
        message = action.payload.messages.join(', ');
      }

      state.saveError = {
        message: message
      };
    },

    [createWheel.fulfilled]: (state, action) => {
      state.createStatus = 'succeeded';
      state.createError = null;
      state.draft.code = action.payload;
      state.equalStatus = false;
    },
    [createWheel.pending]: (state, action) => {
      state.createStatus = 'loading';
      state.createError = null;
    },
    [createWheel.rejected]: (state, action) => {
      let message = 'INTERNAL_SERVER_ERROR';

      if(typeof action.payload === 'string') {
        // error message
        message = action.payload;
      } else if(action.payload.messages.length) {
        message = action.payload.messages.join(', ');
      }

      state.createStatus = 'failed';
      state.createError = {
        message: message,
        fields: action.payload.result?.errors,
      };
    },

    [changeItemOwner.fulfilled]: (state, action) => {
      // Clear state if owner changes
      return initialState;
    }
  }
});

export const { clearSaveStatus, clearCreateStatus, resetStatus } = wheelSlice.actions;

export const selectWheel = state => state.wheel;

export const selectFetchStatus = state => ({
  fetchStatus: state.wheel.fetchStatus,
  fetchError: state.wheel.fetchError,
  draft: state.wheel.draft,
  published: state.wheel.published,
});

export const selectCreateStatus = state => ({
  status: state.wheel.createStatus,
  error: state.wheel.createError,
  wheel: state.wheel.draft,
});

export const selectMaster = state => state.wheel.master;
export const selectEqualStatus = state => state.wheel.equalStatus;
export const selectAccess = state => state.wheel.canEdit;

export const selectSaveStatus = state => ({
  saveStatus: state.wheel.saveStatus,
  saveError: state.wheel.saveError,
});


export default wheelSlice.reducer;
